import React, { createContext, useState, useEffect, useContext } from 'react'
import api from '../utils/axios'

const AuthContext = createContext({})

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    const storedUser = localStorage.getItem('user')

    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser))
      } catch (error) {
        console.error('Erro ao recuperar usuário:', error)
        localStorage.removeItem('token')
        localStorage.removeItem('user')
      }
    }
    setLoading(false)
  }, [])

  const login = async (cpf, password) => {
    try {
      const response = await api.post('/auth/login.php', {
        cpf,
        password
      })

      if (response.data.success) {
        const { token, user } = response.data
        localStorage.setItem('token', token)
        localStorage.setItem('user', JSON.stringify(user))
        setUser(user)
        return { success: true }
      } else {
        return { success: false, message: response.data.message || 'Erro ao fazer login' }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao conectar com o servidor'
      }
    }
  }

  // Login exclusivo da área administrativa (backend deve validar na tabela `usuarios`)
  const loginAdmin = async (cpf, password) => {
    try {
      const response = await api.post('/auth/login_admin.php', {
        cpf,
        password
      })

      if (response.data.success) {
        const { token, user } = response.data
        localStorage.setItem('token', token)
        localStorage.setItem('user', JSON.stringify(user))
        setUser(user)
        return { success: true }
      } else {
        return { success: false, message: response.data.message || 'Erro ao fazer login' }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao conectar com o servidor'
      }
    }
  }

  const register = async (userData) => {
    try {
      const response = await api.post('/auth/register.php', userData)

      if (response.data.success) {
        return { success: true, message: response.data.message }
      } else {
        return { success: false, message: response.data.message || 'Erro ao cadastrar' }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao conectar com o servidor'
      }
    }
  }

  const logout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    setUser(null)
  }

  const updateUser = (updatedUser) => {
    setUser(updatedUser)
    localStorage.setItem('user', JSON.stringify(updatedUser))
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        loginAdmin,
        register,
        logout,
        updateUser,
        loading,
        isAuthenticated: !!user
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

